var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _c("header", { staticClass: "row align-items-center no-margin" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn no-bg",
            on: {
              click: function($event) {
                return _vm.onClickBack()
              }
            }
          },
          [
            _vm.section.prev == "choose-product"
              ? _c("i", { staticClass: "fas fa-times" })
              : _vm._e(),
            _vm._v(" "),
            _vm.section.prev == "choose-attribute"
              ? _c("i", { staticClass: "fas fa-chevron-left" })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col text-center" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.getProductFullName(
                _vm.product.product_name,
                _vm.getSku(_vm.product.prices, _vm.sku_id).attributes
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col text-center" })
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "section" }, [
      _c(
        "div",
        { staticClass: "wrapper-calculator" },
        [
          _c("span", { staticClass: "label" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("message.price")) + "\n      ")
          ]),
          _vm._v(" "),
          _c("calculator-view", {
            attrs: { compare: false },
            on: { submit: _vm.onSubmitCalc }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08a3227b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a3227b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/include/CustomPrice.vue
// module id = null
// module chunks = 